import React from 'react'
import { useDispatch } from 'react-redux'
import { SuperAdminContext } from '../../context/SuperAdminProvider'
import { useT } from '../../i18n'
import { deleteBlog } from '../../redux/actions'
import { Blog } from '../../redux/reducers/blog.reducer'
import { AppDispatch } from '../../redux/store'
import style from '../../styles/pages/blog.module.scss'
import { date } from '../../utils'
import { ToastType, useToast } from '../ToastProvider'
import Button from '../utils/Button'
// import draftToHtml from 'draftjs-to-html'
// import { convertToRaw } from 'draft-js'

export interface BlogCardProps {
    blog?: Blog
    onMore?: () => void
}

// export const stripHTML=(myString:string)=> {
//     return myString.replace( /(<([^>]+)>)/ig, '');
//  }

const BlogCard = (props: BlogCardProps) => {

    const toast = useToast()
    const t = useT()

    const dispatch = useDispatch<AppDispatch>()

    const adminContext = React.useContext(SuperAdminContext)

    const handleDelete = (value: string) => {

        if (value !== undefined) {
            dispatch(deleteBlog(value)).then(text => {
                toast(text, ToastType.SUCCESS)
            }).catch(text => {
                toast(text, ToastType.ERROR)
            })
        }
    }
    return <>
        <div className="row border rounded m-1">
            <div className="col sm-12">
                <div className='w-100 p-2  mb-2'>
                    <h5 className={style.title}>{props.blog?.title}</h5>
                    <div><img src={props.blog?.imageUrl} alt={'blog name'} className={style.blogImage} /></div>
                    {/* <div className={style.title}>{props.blog?.title}</div> */}
                    <div className={style.blogDescription}>{props.blog?.description}</div>
                    <div dangerouslySetInnerHTML={{ __html: props.blog?.content! }} className={style.content}></div>
                    <div > <span className={style.blogDate}>{date(' MON d,Y', props.blog?.createdAt)} | <span className='text-primary text-capitalize'>{props.blog?.author}</span></span></div>

                    <div className='d-flex justify-content-end hstack gap-5'>
                        <Button className={style.blogButton} onClick={() => adminContext?.onEditBlog?.(props.blog?.id!)}>{t("Edit")}</Button>
                        <Button className={style.blogButton} onClick={() => handleDelete(props.blog?.id!)}>{t("Delete")}</Button>
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default BlogCard
